import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import { useEffect, useState } from "react";

import { djangoApi } from "../../utils/axios/axios.utils";
import { useDispatch, useSelector } from "react-redux";

import { setProducts } from "../../store/products/products.action";
import { findProdByIdAndPk, findProdByIdMultiplo, selectProducts } from "../../store/products/products.selector";

import CircularProgress from '@mui/material/CircularProgress';

import { Chip } from '@mui/material';
import TextField from '@mui/material/TextField';
// import CloseIcon from '@mui/icons-material/Close'; // Import the Close icon

import ProductsPageSection from "../../components/products";
import ProdModal from "./find-prod-modal";

import CachedIcon from '@mui/icons-material/Cached';
import LoadingButton from '@mui/lab/LoadingButton';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import UpdatePlantioInput from "./update-prods";
import { timeOutBipInput } from "../../utils/form-utils";



const ProdsPage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const MySwal = withReactContent(Swal);

    const dispatch = useDispatch()

    const [isLoading, setIsLoading] = useState(false);

    const productsData = useSelector(selectProducts)



    const [selectedId, setSelectedId] = useState(null);

    const fullState = useSelector(state => state);
    const selectedProd = useSelector(findProdByIdAndPk(selectedId))

    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState(null);

    const [value, setValue] = useState('');

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    useEffect(() => {
        if (open) {
            if (selectedProd.length === 0) {
                setOpen(!open)
                MySwal.fire("Ops!!", `Produto não encontrado: ${selectedId}!!`, "error").then(() => {
                    // Code to execute after the alert is confirmed
                    // For example, redirect to another page or refresh data
                })
            }
        }
    }, [open, selectedProd]);


    useEffect(() => {
        if (productsData) {
            // console.log('prodsData: ', productsData)
            const productKeys = Object.keys(productsData);
            const newProdsKeys = [...productKeys, 'Todos']
            // console.log('productsKeysss: ', newProdsKeys)
            setModels(newProdsKeys)
        }
    }, []);

    useEffect(() => {
        if (models.length > 0) {
            setSelectedModel(models.sort((a, b) => a.localeCompare(b))[0])
        }
    }, [models]);

    useEffect(() => {
        if (productsData) {
            // console.log('prodsData: ', productsData)
            const productKeys = Object.keys(productsData);
            const newProdsKeys = [...productKeys, 'Todos']
            // console.log('productsKeysss: ', newProdsKeys)
            setModels(newProdsKeys)
        }
    }, [productsData]);

    const getProductsData = async () => {
        setIsLoading(true)
        try {
            await djangoApi
                .get("products/register_prods/get_all_prods/", {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
                .then((res) => {
                    const { dados } = res.data;
                    dispatch(setProducts(dados))
                    setIsLoading(false)
                });
        } catch (err) {
            window.alert(err);
            console.log("Erro ao alterar as aplicações", err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };
    useEffect(() => {
        const getProductsData = async () => {
            setIsLoading(true)
            try {
                await djangoApi
                    .get("products/register_prods/get_all_prods/", {
                        headers: {
                            Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                            "Content-Type": "application/json"
                        }
                    })
                    .then((res) => {
                        const { dados } = res.data;
                        dispatch(setProducts(dados))
                        setIsLoading(false)
                    });
            } catch (err) {
                console.log("Erro ao alterar as aplicações", err);
                window.alert(err);
                setIsLoading(false)
            } finally {
                // pass
                setIsLoading(false)
            }
        };
        if (!productsData || productsData?.length === 0) {
            console.log("consultando dados")
            getProductsData();
        }
    }, []);

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const formatNumber = (data) => {
        return data.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }





    const handleChange = (event) => {
        // TODO
        // check here to get size if it is anel
        // console.log('value here: ', event.target.value)
        setValue(event.target.value.toString());
        if (event.target.value.length === 6) {
            setTimeout(() => {
                let idToEdit = event.target.value.toString()
                const checkAneis = productsData.aneis.filter((data) => data.id_produto.toString() === idToEdit)

                const selectorFn = findProdByIdMultiplo(idToEdit);
                const howManyNow = selectorFn(fullState);
                // console.log('howManyNow', howManyNow)
                if (checkAneis.length > 1) {
                    const totalAvailable = checkAneis.reduce((acc, curr) => acc += curr.quantity_available, 0)
                    const optionsTable = `
                <table style="width:100%; text-align:left; border-collapse: collapse;">
                    <thead>
                        <tr>
                            <th style="border: 1px solid #ccc; padding: 8px;">ID</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Cor</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Tipo</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Tamanho</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Qtd Inicial</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Qtd Disponível</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Preço</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${checkAneis
                            .map(
                                (item) => `
                            <tr>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.id_produto}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.color__color}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.model}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.tamanho}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.initial_inventory}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.quantity_available}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">R$ ${formatNumber(item.charged_price)}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">
                                    <button 
                            class="select-option" 
                            data-id="${item.id_produto}-${item.pk}" 
                            style="padding: 5px 10px; background-color: ${item?.devolvido ? '#007bff' : '#007bff'
                                    }; color: #fff; border: none; cursor: ${item?.devolvido ? 'pointer' : 'pointer'
                                    };"
                        >
                                        Selecionar
                                    </button>
                                </td>
                            </tr>`
                            )
                            .join('')}
                    </tbody>
                </table>`;

                    // Use SweetAlert2 to show the table
                    MySwal.fire({
                        title: `Múltiplos Anéis Econtrados!!`,
                        icon: "question",
                        html: `
                            <span class="swal2-title" style="margin-top: 0; font-size: 20px; font-weight: bold;">Unidades disponíveis: ${totalAvailable}</span>
                            <p>Selecione 1 opção abaixo:</p>
                            ${optionsTable}
                        `,
                        showConfirmButton: false, // Disable the default "OK" button
                        width: '800px', // <--- ADICIONE ESTA LINHA (ajuste o valor)
                        didOpen: () => {
                            // Add event listeners to buttons after the modal is rendered
                            document.querySelectorAll('.select-option').forEach((button) => {
                                button.addEventListener('click', (e) => {
                                    const selectedId = e.target.getAttribute('data-id');
                                    setSelectedId(selectedId)
                                    MySwal.close(); // Close the modal
                                    setOpen(!open)
                                    // Use the selected option here (e.g., redirect or update state)
                                });
                            });
                        },
                    });
                } else if (howManyNow?.length > 1) {
                    const totalAvailable = howManyNow.reduce((acc, curr) => acc += curr.quantity_available, 0)
                    const optionsTable = `
                <table style="width:100%; text-align:left; border-collapse: collapse;">
                    <thead>
                        <tr>
                            <th style="border: 1px solid #ccc; padding: 8px;">ID</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Cor</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Tipo</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Qtd Inicial</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Qtd Disponível</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Preço</th>
                            <th style="border: 1px solid #ccc; padding: 8px;">Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${howManyNow
                            .map(
                                (item) => `
                            <tr>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.id_produto}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.color__color}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.model}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.initial_inventory}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">${item.quantity_available}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">R$ ${formatNumber(item.charged_price)}</td>
                                <td style="border: 1px solid #ccc; padding: 8px;">
                                    <button 
                            class="select-option" 
                            data-id="${item.id_produto}-${item.pk}"  
                            style="padding: 5px 10px; background-color: ${item?.devolvido ? '#007bff' : '#007bff'
                                    }; color: #fff; border: none; cursor: ${item?.devolvido ? 'pointer' : 'pointer'
                                    };"
                        >
                                        Selecionar
                                    </button>
                                </td>
                            </tr>`
                            )
                            .join('')}
                    </tbody>
                </table>`;

                    // Use SweetAlert2 to show the table
                    MySwal.fire({
                        title: `Múltiplos Produtos Econtrados!!`,
                        icon: "info",
                        html: `
                            <h2 class="swal2-title" style="margin-top: 0;">Unidades disponíveis: ${totalAvailable}</h2>
                            <p>Selecione 1 opção abaixo:</p>
                            ${optionsTable}
                        `,
                        showConfirmButton: false, // Disable the default "OK" button
                        width: '800px', // <--- ADICIONE ESTA LINHA (ajuste o valor)
                        didOpen: () => {
                            // Add event listeners to buttons after the modal is rendered
                            document.querySelectorAll('.select-option').forEach((button) => {
                                button.addEventListener('click', (e) => {
                                    const selectedId = e.target.getAttribute('data-id');
                                    setSelectedId(selectedId)
                                    MySwal.close(); // Close the modal
                                    setOpen(!open)
                                    // Use the selected option here (e.g., redirect or update state)
                                });
                            });
                        },
                    });
                } else {
                    setSelectedId(event.target.value)
                    setOpen(!open)

                }
                setTimeout(() => {
                    setValue('')
                }, 200);
            }, timeOutBipInput);
        } else {
            setSelectedId(null)
        }
    };
    const handleChangeOnTbale = (value) => {
        setValue(value);
        if (value.length === 6) {
            setSelectedId(value)
            setOpen(!open)
            setTimeout(() => {
                setValue('')
            }, 200);
        } else {
            setSelectedId(null)
        }
    };

    const handleChip = (data) => {
        setSelectedModel(data)
        setSelectedId(null)
    }

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress size={50} color="success" />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                // alignItems: 'center',
                height: "100%",
                width: '100%',
                paddingTop: "60px",
            }}
        >
            <Box
                sx={{
                    width: '200px',
                    borderRight: `0.5px solid ${colors.primary[200]}`,
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '0px 10px'
                }}
            >
                <Box
                    sx={{
                        padding: '10px',
                        display: 'flex',
                        flexDirection: 'row'
                    }}
                >
                    <TextField
                        id="outlined-basic"
                        label="ID"
                        variant="standard"
                        value={value}
                        onChange={handleChange}
                        inputProps={{ maxLength: 6 }} // Set the max length here
                    />
                    {/* <IconButton
                        onClick={handleClear}
                        style={{ marginLeft: '10px' }} // Add some space between the button and the TextField
                        size="small" // Small size for a more compact button
                        aria-label="clear"
                    >
                        <CloseIcon />
                    </IconButton> */}
                </Box>

                {
                    models && models.sort((a, b) => a.localeCompare(b)).map((data, key) => {
                        return (
                            <Chip
                                key={key} // Use the key as a unique identifier
                                label={capitalizeFirstLetter(data)} // Display the key as the chip label
                                onClick={() => handleChip(data)} // Example click handler
                                style={{
                                    margin: '4px',
                                    width: '100%',
                                    fontSize: '16px',
                                    borderRadius: '4px',
                                    backgroundColor: selectedModel === data && colors.pink[700]
                                }} // Optional styling
                            />
                        )
                    })
                }
                <Box
                    sx={{
                        marginTop: 'auto',
                        marginBottom: '20px'
                    }}
                >
                    <UpdatePlantioInput />
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    paddingLeft: '10px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        padding: '0px 40px'
                    }}
                >
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        startIcon={<CachedIcon />}
                        variant="contained"
                        color="success"
                        onClick={() => getProductsData()}
                        sx={{ marginRight: '0', color: 'white' }}
                    >
                        Atualizar
                    </LoadingButton>
                </Box>
                <ProdModal
                    handleClose={handleClose}
                    handleOpen={handleOpen}
                    open={open}
                    setOpen={setOpen}
                    selectedProd={selectedProd}
                />

                <ProductsPageSection selectedModel={selectedModel} handleOpen={handleOpen} handleChangeOnTbale={handleChangeOnTbale} />
            </Box>

        </Box>
    );
}

export default ProdsPage;